import { render, staticRenderFns } from "./FixturesResults.vue?vue&type=template&id=702fc66c&scoped=true"
import script from "./FixturesResults.vue?vue&type=script&lang=js"
export * from "./FixturesResults.vue?vue&type=script&lang=js"
import style0 from "./FixturesResults.vue?vue&type=style&index=0&id=702fc66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702fc66c",
  null
  
)

export default component.exports